import { ReactNode } from "react";
import { BasePanel } from "components/BasePanel";
import { EmptyList } from "components/empty/EmptyList";
import { ListLoading } from "components/skeletons/ListLoading";

export interface LoadingPanelProps {
  title?: string;
  loadingText: string;
  customLoadingComponent?: ReactNode;
  classes?: {
    container?: string;
    title?: string;
  };
}

export const LoadingPanel = ({
  title,
  loadingText,
  customLoadingComponent,
  classes,
}: LoadingPanelProps) => {
  return (
    <BasePanel
      title={title}
      isEmpty
      emptyComponent={
        <EmptyList
          title={loadingText}
          image={
            customLoadingComponent || (
              <div className="translate-y-16 -translate-x-[7.2rem]">
                <ListLoading />
              </div>
            )
          }
          classes={classes}
        />
      }
    />
  );
};
